// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsStartMapping_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M27 4.77836C26.88 4.7241 26.7617 4.67067 26.6454 4.61812L26.6453 4.6181C26.1522 4.39534 25.6939 4.18831 25.2869 4H19.885C19.6676 4.29366 19.5056 4.64063 19.4126 5.03311C19.1328 6.21423 19.799 7.15438 20.7197 8.45369C21.2887 9.25661 21.9548 10.1967 22.555 11.4155C23.3968 13.1252 25.146 13.8775 27 13.8704V4.77836ZM29 13.5783V15V16.1024C28.65 15.9117 28.1904 15.9201 27.5662 16.2187C25.587 17.1656 24.5875 16.1568 23.587 15.1471C23.2493 14.8062 22.9114 14.4652 22.5357 14.1993C21.7702 13.6976 19.8852 14.4405 17.9885 15.1881L17.9885 15.1881C16.5215 15.7662 15.0475 16.3472 14.0789 16.3573C11.3027 16.3861 8.60229 17.6883 8.13606 19.5281C8.01322 20.0129 8.03703 20.5056 8.16804 21H19V23H9.18969H4H2V21V19.2429V11.2071V8.52726V4V2H4H8.77429H27H29V4V5.69611V13.5783ZM11.4028 4H4V9.21341C4.03836 9.21666 4.07684 9.21937 4.11543 9.22153C4.41557 9.23836 4.69662 9.2503 4.96057 9.26153C6.51918 9.32779 7.48186 9.36871 8.26016 10.2378C8.65414 10.7584 8.94543 11.3254 9.21655 11.8531C9.77704 12.9439 10.2514 13.8672 11.3688 13.8672C11.4865 13.8672 11.6093 13.8677 11.7362 13.8681C13.8438 13.8762 17.1071 13.8886 17.7586 11.8347C17.802 11.6981 17.846 11.5621 17.8897 11.427C18.5428 9.40839 19.1288 7.59728 16.377 7.18906C13.4412 6.75353 12.4049 6.46331 11.8868 4.86631C11.7668 4.54153 11.6042 4.25816 11.4028 4ZM4 11.9086V19.2578C4.56746 19.1513 5.13492 18.9507 5.70238 18.656C7.47857 17.7333 7.47857 15.888 7.47857 14.0427C7.47857 12.8125 5.89973 12.4024 4.32089 11.9923L4.32088 11.9923L4.32088 11.9923C4.21375 11.9645 4.10663 11.9367 4 11.9086ZM22 18L30 24L22 30V18Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsStartMapping is a generated icon component.
 */
let IconRmsStartMapping = IconRmsStartMapping_1 = class IconRmsStartMapping extends IconBaseElement {
    render() {
        return html `${IconRmsStartMapping_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsStartMapping.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsStartMapping = IconRmsStartMapping_1 = __decorate([
    customElement('zui-icon-rms-start-mapping')
], IconRmsStartMapping);
export { IconRmsStartMapping };
